export let applicationHeight: number;
export const sendPostMessage = (document: any) => {
    if (applicationHeight !== document.getElementById("bqs-wrapper").offsetHeight) {
        applicationHeight = document.getElementById("bqs-wrapper").offsetHeight;

        window.parent.postMessage(
            {
                frameHeight: applicationHeight,
            },
            "*",
        );
        //console.log(applicationHeight); // check the message is being sent correctly
    }
};
